import { notify } from '@/components'
import { useMaintenanceStore } from '@/stores/useMaintenanceStore'
import type { ErrorCode, ErrorResponse, ForbiddenErrorResponse } from '@/types'

export const errorHandler = ({ error, apiStatus, apiError }: ErrorResponse) => {
  if (apiStatus === 503) {
    useMaintenanceStore.getState().triggerMaintenanceRedirect()
    return
  }

  if (error) {
    console.error(error)
  }

  // 正常レスポンスの場合は何もしない
  if (apiStatus === undefined || apiStatus < 400) {
    return
  } else if (isForbiddenErrorResponse(apiError) && apiStatus === 403) {
    permissionErrorHandler(apiError?.code)
  } else {
    notify.error('エラーが発生しました')
  }
}

export function isForbiddenErrorResponse(v: unknown): v is ForbiddenErrorResponse {
  return (
    v !== null &&
    v !== undefined &&
    typeof v === 'object' &&
    (v as ForbiddenErrorResponse).code !== undefined &&
    (v as ForbiddenErrorResponse).message !== undefined
  )
}

function permissionErrorHandler(code: ErrorCode) {
  if (isPermissionError(code)) {
    notify.warning('この画面を閲覧・操作する権限がありません')
  }
}

export function isPermissionError(code: ErrorCode) {
  switch (code) {
    case 'PermissionError/TargetUserOperationNotAllowed':
    case 'PermissionError/ReadNotAllowed':
    case 'PermissionError/UpdateNotAllowed':
    case 'PermissionError/ManageTenantMaintenanceNotAllowed':
      return true
    default:
      return false
  }
}
